<template>
  <div class="ecg-container">
    <iframe
      id="ecg_iframe"
      :src="ecgUrl"
      frameborder="0"
    ></iframe>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog.content }}</div>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'
import IframeMessenger from '../../utils/iframePostMessage'
import {setSha, throttle, timeToSeconds, traceClickURL, getUserIdentity} from '../../utils/util'
import {handleTraceFunction} from '../../utils/trace'
import {Toast} from 'vant'
import {getEcgTagName} from '../RTCZone/data'
import withRouteTracking from '../../utils/withRouteTracking'
import {getShareInfo} from '../../utils/wxShare'
import {systemRedisDelete, systemRedisGet, systemRedisSet} from '../../api/api'

const Ecg = {
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  data() {
    return {
      ecgUrl: process.env.ecgUrl,
      ecgDomain: process.env.ecgDomain,
      ecgIframeElement: '',
      IframeMessage: null,
      userIdentity: getUserIdentity(),
      cDialog: {
        visible: false,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        content: '',
        cancel: () => {
          this.cDialog.visible = false
        },
        confirm: () => {
          this.cDialog.visible = false
        },
        close: () => {
          this.cDialog.visible = false
        }
      }
    }
  },
  components: {
    CustomDialog
  },
  async mounted() {
    if (this.hasEcgAccess()) {
      this.showPermissionDialog()
      return
    }
    window.sessionStorage.setItem('mainId', '')
    window.sessionStorage.setItem('serviceId', '')
    getShareInfo({
      title: '室早定位助手',
      titleTimeLine: '室早定位助手',
      desc: '智慧交互，循序渐进，养成室早定位决策思维！',
      link: window.location.href,
      linkTimeLine: window.location.href,
      images: `https://iep.jjmc.cn/bw/file/material/image/1945708960574410781.jpg`,
    })
    this.ecgIframeElement = document.getElementById('ecg_iframe')
    this.IframeMessage = new IframeMessenger({
      domain: this.ecgDomain,
      iframeElement: this.ecgIframeElement,
    })
    this.IframeMessage.init()
    this.IframeMessage.registerOnMessage(({action, data}, send) => {
      // 跳转病例详情
      if (action === 'ecg.detail.case') {
        const {id, labelId} = data
        throttle(
          handleTraceFunction({
            functionName: '室早心电图-查看病例详情',
            functionUrl: `caseId=${id}`,
            createTime: new Date().getTime(),
          }),
          1000,
        )
        setTimeout(() => {
          traceClickURL()
        })
        let trackParams = `&entrance=67&businessChannel=67&campId=${labelId}`
        let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${id}${openidBindli}${trackParams}`
      }
      // 跳转图文详情
      if (action === 'ecg.detail.poster') {
        const {id, labelId} = data
        throttle(
          handleTraceFunction({
            functionName: '室早心电图-查看图文详情',
            functionUrl: `postId=${id}`,
            createTime: new Date().getTime(),
          }),
          1000,
        )
        sessionStorage.setItem('entrance', '67')

        this.$router.push({
          path: '/dccDetail',
          query: {
            postId: id,
            fromType: 'ecg',
            entrance: 67,
            channel: 67,
            businessId: labelId,
          }
        })
      }
      // 跳转课程详情
      if (action === 'ecg.detail.course') {
        const {courseId, sectionId, duration, labelId} = data
        const seconds = timeToSeconds(duration)
        throttle(
          handleTraceFunction({
            functionName: '室早心电图-查看课程详情',
            functionUrl: `courseId=${courseId}&sectionId=${sectionId}&duration=${duration}&labelId=${labelId}`,
            createTime: new Date().getTime(),
          }),
          1000,
        )
        sessionStorage.setItem('entrance', '67')
        this.$router.push({
          path: '/courserDetails',
          query: {
            courseId,
            sectionId,
            knowledgeDuration: seconds,
            entrance: 67,
            channel: 67,
            businessId: labelId,
          }
        })
      }
      // 上传病例
      if (action === 'ecg.upload.case') {
        const {id} = data
        if (`${this.userInfo.memberType}` === '1') {
          Toast('医生身份才能上传!')
          return
        }
        throttle(
          handleTraceFunction({
            functionName: '室早心电图-上传病例',
            functionUrl: `labelId=${id}`,
            createTime: new Date().getTime(),
          }),
          1000,
        )
        setTimeout(() => {
          traceClickURL()
        })
        let trackParams = `&entrance=67&businessChannel=67&campId=${id}`
        let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/upload?upload_type=2&label_ids=${id}${openidBindli}${trackParams}`
      }
      // 发贴图文
      if (action === 'ecg.upload.poster') {
        const {id} = data
        throttle(
          handleTraceFunction({
            functionName: '室早心电图-上传图文',
            functionUrl: `labelId=${id}`,
            createTime: new Date().getTime(),
          }),
          1000,
        )
        this.$router.push({
          path: `/addPost`,
          query: {
            labelId: id,
            fromType: 'ecg',
            entrance: 67,
            channel: 67,
            businessId: id,
          }
        })
      }
      // 决策树点击
      if (action === 'ecg.trace.label') {
        const {id} = data
        throttle(
          handleTraceFunction({
            functionName: `室早心电图-点击决策树节点-${getEcgTagName(id)}`,
            functionUrl: `labelId=${id}`,
            createTime: new Date().getTime(),
          }),
          1000,
        )
      }
      // 存页面操作路径
      if (action === 'ecg.cache.set') {
        const {content} = data
        systemRedisSet({
          key: `ecg_${this.userInfo.id}`,
          value: window.btoa(content)
        })
        sessionStorage.setItem('isHaveCache', 1)
      }
      if (action === 'ecg.cache.delete') {
        systemRedisDelete({
          key: `ecg_${this.userInfo.id}`,
        })
      }
    })
    // 等待iframe加载完成
    this.ecgIframeElement.addEventListener('load', async () => {
      if (sessionStorage.getItem('isHaveCache')) {
        try {
          const {code, data} = await systemRedisGet({
            key: `ecg_${this.userInfo.id}`,
          })
          if (code === 0) {
            this.IframeMessage.sendMessageToIframe({
              action: 'ecg.cache.get',
              data: {
                content: window.atob(data)
              }
            })
          } else {
            throw new Error('ecg缓存获取失败')
          }
        } catch (e) {
          console.error('ecg缓存获取失败')
        }
      } else {
        systemRedisDelete({
          key: `ecg_${this.userInfo.id}`,
        })
      }
    })
  },
  beforeDestroy() {
    this.IframeMessage && this.IframeMessage.removeListener()
  },
  methods: {
    hasEcgAccess() {
      return this.userIdentity.veevaStatus === '待验证' && this.userIdentity.isDueDate
    },
    showPermissionDialog() {
      this.cDialog.visible = true
      this.cDialog.title = '提示'
      this.cDialog.content = '敬请期待!'
      this.cDialog.confirm = () => {
        this.cDialog.visible = false
        this.$router.replace('/home')
      }
      this.cDialog.cancel = this.cDialog.confirm
      this.cDialog.close = this.cDialog.confirm
    },
  }
}

export default withRouteTracking(Ecg)
</script>

<style scoped lang="less">
.ecg-container {
  width: 100%;
  height: 100%;
}
iframe {
  width: 100%;
  height: 100%;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/JJMC_ECGenius/index.vue